/** The three steps a switch is drawn at. */
export type MibSwitchSize = 'sm' | 'md' | 'lg';

/** What one step gives the track, the knob that travels along it, and the label beside them. */
export interface SwitchSizeConfig {
  track: string;
  knob: string;
  travel: string;
  /** Half of `travel`: where the knob rests while the switch is mixed. */
  middle: string;
  text: string;
  gap: string;
}

/**
 * The sliding mark of Foundations / Shape and spacing: the knob travels the track's width less its
 * own and its two-pixel inset, so `travel` is not free — change a track or a knob and it moves too.
 */
export const SWITCH_SIZE: Record<MibSwitchSize, SwitchSizeConfig> = {
  sm: {
    track: 'h-5 w-9',
    knob: 'size-4',
    travel: 'translate-x-4',
    middle: 'translate-x-2',
    text: 'text-xs/4.5',
    gap: 'gap-1.5',
  },
  md: {
    track: 'h-6 w-11',
    knob: 'size-5',
    travel: 'translate-x-5',
    middle: 'translate-x-2.5',
    text: 'text-sm/5',
    gap: 'gap-2',
  },
  lg: {
    track: 'h-7 w-13',
    knob: 'size-6',
    travel: 'translate-x-6',
    middle: 'translate-x-3',
    text: 'text-base/6',
    gap: 'gap-2.5',
  },
};
